import {dataService} from "services/data.service"
import {useDispatch, useSelector} from "react-redux"
import {Checkbox} from "antd"
import Label from "components/Label"
import {excludeEffect, includedEffects, includeEffect} from "redux/graphSlice"

/**
 *
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function SideEffectSelection() {

	const dispatch = useDispatch()
	const effects = dataService.getEffects()
	const included = useSelector(includedEffects)
	const isIncluded = (effect) => included.includes(effect)
	const isEfficacy = (effect) => effect === "EFFICACY"

	const onChange = (effect) => (event) => {
		if (event.target.checked) {
			dispatch(includeEffect(effect))
		} else {
			dispatch(excludeEffect(effect))
		}
	}

	return (
		<div className="side-effect-selection">
			{
				effects.filter(effect => !isEfficacy(effect))
				.map(effect =>
					<Checkbox className={effect}
							  checked={isIncluded(effect)}
							  onChange={onChange(effect)}
					>
						<Label id={effect}/>
					</Checkbox>
				)
			}
		</div>
	)

}
